import { Alert } from "react-bootstrap";

export default function FormError({ children }) {
    if (children) {
        return <Alert variant='danger'>
            {children}
        </Alert>
    }
    return <></>
}